<template>
    <v-app>
        <project-type-setup :dialog="projectTypeDialog" :data="data" @update:dialog="projectTypeDialog = $event" />  
        <contact-setup :dialog="contactDialog" :data="data" @update:dialog="contactDialog = $event" />  
        <project-theme-setup :dialog="projectThemeDialog" :data="data" @update:dialog="projectThemeDialog = $event" />  
        <sales-order-setup :dialog="dialog" :data="data" @update:dialog="dialog = $event" @save-author="saveAuthorHandler" />

        <v-container fluid>
            <template v-if="$insertAccess($route.path)">
                <v-form @submit.prevent="submit">
                    <v-row>
                        <v-col cols="12">
                            <v-expansion-panels v-model="panel">
                                <v-expansion-panel>
                                   <v-expansion-panel-title
                                        color="blue-grey-lighten-5"
                                        class="panel-header font-weight-medium text-primary"
                                    >
                                        <v-icon start color="primary" class="mr-2">mdi-information-outline</v-icon>
                                        <span>{{ isEntryMode ? "Add Project Info" : "Update Project Info" }}</span>
                                    </v-expansion-panel-title>
                                    
                                    <v-expansion-panel-text>
                                        <v-row class="py-2 no-gutters justify-space-around">
                                            <v-col lg="4" md="4" cols="12">
                                                <v-date-input
                                                input-format="dd/mm/yyyy"
                                                prepend-icon=""
                                                prepend-inner-icon="mdi-calendar"
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                class="px-2"
                                                v-model="project_date.value.value"
                                                autocomplete="off"
                                                clearable
                                                :error-messages="project_date.errorMessage.value"
                                                >
                                                    <template #label>
                                                        Project Date
                                                        <span class="text-red-accent-4">*</span>
                                                    </template>
                                                </v-date-input>

                                                <v-autocomplete
                                                    density="compact"
                                                    variant="outlined"
                                                    bg-color="grey-lighten-4"
                                                    class="px-2"
                                                    v-model="project_type_id.value.value"
                                                    :error-messages="project_type_id.errorMessage.value"
                                                    clearable
                                                    :items="getProjectTypeList"
                                                    :item-title="item => item ? `${item.code} - ${item.name}` : ''" 
                                                    autocomplete="off"                                               
                                                    item-value="id"
                                                >
                                                    <template #label>
                                                        Service Type <span class="text-red-accent-4">*</span>
                                                    </template>
                                                    <template v-slot:append-inner>
                                                        <v-slide-x-reverse-transition mode="out-in">
                                                            <v-icon
                                                            @mousedown.stop="openAddProjectType"
                                                            icon="mdi-plus-circle-outline"
                                                            color="primary"
                                                            size="24"
                                                            class="cursor-pointer"
                                                            ></v-icon>
                                                        </v-slide-x-reverse-transition>
                                                    </template>
                                                </v-autocomplete>

                                                <v-autocomplete
                                                    density="compact"
                                                    variant="outlined"
                                                    bg-color="grey-lighten-4"
                                                    class="px-2"
                                                    v-model="contact_id.value.value"
                                                    :error-messages="contact_id.errorMessage.value"
                                                    clearable
                                                    :items="getContactList"
                                                    :item-title="item => item ? `${item.code} - ${item.name}` : ''" 
                                                    autocomplete="off"                                               
                                                    item-value="id"
                                                >
                                                    <template #label>
                                                        Sales Person <span class="text-red-accent-4">*</span>
                                                    </template>
                                                    <template v-slot:append-inner>
                                                        <v-slide-x-reverse-transition mode="out-in">
                                                            <v-icon
                                                            @mousedown.stop="openAddContact"
                                                            icon="mdi-plus-circle-outline"
                                                            color="primary"
                                                            size="24"
                                                            class="cursor-pointer"
                                                            ></v-icon>
                                                        </v-slide-x-reverse-transition>
                                                    </template>
                                                </v-autocomplete>

                                                <v-text-field
                                                v-model="project_title.value.value"
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                class="px-2"
                                                clearable
                                                :error-messages="project_title.errorMessage.value"
                                                >
                                                    <template #label>
                                                        Project Title
                                                        <span class="text-red-accent-4">*</span>
                                                    </template>
                                                </v-text-field>

                                                <v-autocomplete
                                                    density="compact"
                                                    variant="outlined"
                                                    bg-color="grey-lighten-4"
                                                    class="px-2"
                                                    v-model="customer_id.value.value"
                                                    @update:model-value="onCustomerChange"
                                                    :error-messages="customer_id.errorMessage.value"
                                                    clearable
                                                    :items="getCustomerMapList"
                                                    :item-title="(item) => item && item.customer ? `${item.customer.company_name ? item.customer.company_name : item.customer.company_owner_name ? item.customer.company_owner_name : ''} - ${item.customer.code}` : ''"
                                                    autocomplete="off"                                               
                                                    item-value="id"
                                                >
                                                    <template #label>
                                                        Customer <span class="text-red-accent-4">*</span>
                                                    </template>
                                                    <!-- <template v-slot:append-inner>
                                                        <v-slide-x-reverse-transition mode="out-in">
                                                            <v-icon
                                                            @mousedown.stop="openAddProjectTheme"
                                                            icon="mdi-plus-circle-outline"
                                                            color="primary"
                                                            size="24"
                                                            class="cursor-pointer"
                                                            ></v-icon>
                                                        </v-slide-x-reverse-transition>
                                                    </template> -->
                                                </v-autocomplete>

                                                 <v-textarea
                                                    v-model="customer_address.value.value"
                                                    label="Customer Address"
                                                    rows="2"
                                                    variant="outlined"
                                                    density="compact"
                                                    bg-color="grey-lighten-4"
                                                    class="px-2"
                                                    autocomplete="off"
                                                    readonly
                                                    :error-messages="customer_address.errorMessage.value"
                                                ></v-textarea>
                                            </v-col>

                                            <v-col lg="4" md="4" cols="12">
                                                <v-text-field
                                                v-model="amount.value.value"
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                class="px-2"
                                                :error-messages="amount.errorMessage.value"
                                                clearable
                                                >
                                                    <template #label>
                                                        Project Value
                                                        <span class="text-red-accent-4">*</span>
                                                    </template>
                                                </v-text-field>

                                                <v-text-field
                                                v-model="expense_limit.value.value"
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                class="px-2"
                                                type="number"
                                                :error-messages="expense_limit.errorMessage.value"
                                                clearable
                                                >
                                                    <template #label>
                                                        Project Expense Limit
                                                    </template>
                                                </v-text-field>

                                                <v-date-input
                                                input-format="dd/mm/yyyy"
                                                v-model="start_date.value.value"
                                                prepend-icon=""
                                                prepend-inner-icon="mdi-calendar"
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                class="px-2"
                                                autocomplete="off"
                                                :error-messages="start_date.errorMessage.value"
                                                clearable
                                                >
                                                    <template #label>
                                                        Project Agreed Date
                                                        <span class="text-red-accent-4">*</span>
                                                    </template>
                                                </v-date-input>

                                                <v-date-input
                                                input-format="dd/mm/yyyy"
                                                v-model="end_date.value.value"
                                                prepend-icon=""
                                                prepend-inner-icon="mdi-calendar"
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                class="px-2"
                                                autocomplete="off"
                                                :error-messages="end_date.errorMessage.value"
                                                clearable
                                                >
                                                    <template #label>
                                                        Project Delivery Date
                                                        <span class="text-red-accent-4">*</span>
                                                    </template>
                                                </v-date-input>
                                                

                                                <v-text-field
                                                v-model="approval_ref.value.value"
                                                label="Approval Reference"
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                class="px-2"
                                                :error-messages="approval_ref.errorMessage.value"
                                                clearable
                                                ></v-text-field>

                                                <v-autocomplete
                                                    v-model="registration_type.value.value"
                                                    :items="registrationTypes"
                                                    :item-title="(item) => item ? item.display_text : ''"
                                                    item-value="id"
                                                    variant="outlined"
                                                    density="compact"
                                                    bg-color="grey-lighten-4"
                                                    class="px-2"
                                                    clearable
                                                    autocomplete="off"
                                                    :error-messages="registration_type.errorMessage.value"
                                                >
                                                    <template #label>
                                                        Project Status
                                                        <span class="text-red-accent-4">*</span>
                                                    </template>
                                                </v-autocomplete>
                                            </v-col>
                                            
                                            <v-col lg="4" md="4" cols="12">
                                                <v-text-field
                                                v-model="donor_name.value.value"
                                                label="Donor Name"
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                class="px-2"
                                                :error-messages="donor_name.errorMessage.value"
                                                clearable
                                                >                                                
                                                    <template #label>
                                                        Donor Name
                                                    </template>
                                                </v-text-field>
                                                <v-text-field
                                                v-model="whatsapp_link.value.value"
                                                label="Whatsapp Group Link"
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                class="px-2"
                                                :error-messages="whatsapp_link.errorMessage.value"
                                                clearable
                                                ></v-text-field>

                                                <v-text-field
                                                v-model="google_link.value.value"
                                                label="Google Drive Link"
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                class="px-2"
                                                :error-messages="google_link.errorMessage.value"
                                                clearable
                                                ></v-text-field>

                                                <v-textarea
                                                v-model="address.value.value"
                                                label="Project Address"
                                                rows="3"
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                class="px-2"
                                                :error-messages="address.errorMessage.value"
                                                clearable
                                                ></v-textarea>

                                                <v-textarea
                                                    v-model="description.value.value"
                                                    label="Project Description"
                                                    rows="3"
                                                    variant="outlined"
                                                    density="compact"
                                                    bg-color="grey-lighten-4"
                                                    class="px-2"
                                                    autocomplete="off"
                                                    :error-messages="description.errorMessage.value"
                                                    clearable
                                                ></v-textarea>

                                                <input v-model="project_id.value.value" type="hidden">
                                            </v-col>
                                        </v-row>
                                    </v-expansion-panel-text>
                                </v-expansion-panel>
                            </v-expansion-panels>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col>
                        <div class="text-right pr-2">
                            <v-btn
                            v-if="$insertAccess($route.path)"
                            @click="openAddAuthor"
                            color="primary"
                            variant="tonal"
                            prepend-icon="mdi mdi-plus"
                            size="small"
                            rounded="xl"
                            >
                            Add Payment
                            </v-btn>
                        </div>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12">
                           <v-card class="mt-0 elevation-1 rounded-lg">
                                <v-card-title class="d-flex align-center py-2 px-4 bg-blue-grey-lighten-5" style="font-size: 1.1rem;">
                                    <v-icon color="primary" size="small" class="mr-2">mdi-account-multiple</v-icon>
                                    <span class="font-weight-medium text-primary">Payment Details</span>
                                   
                                    <v-btn class="ms-auto" prepend-icon="mdi mdi-download" variant="outline" color="primary"
                                                    @click="exportToExcel">EXCEL</v-btn>

                                </v-card-title>

                                <v-divider></v-divider>

                                <v-card-text>
                                    <v-data-table
                                        :headers="headers"
                                        :items="authors"
                                        v-model:items-per-page="itemsPerPage"
                                        :search="search"
                                        density="comfortable"
                                        class="pa-2 elevation-1 rounded-lg"
                                        :items-per-page="-1"
                                        hover
                                        hide-default-footer
                                        >
    
                                        <template v-slot:item.index="{ index }">
                                            {{ ++index }}
                                        </template>
    
                                        <template v-slot:item.status="{ item }">
                                            <v-chip v-if="item.status == 1" color="success" size="small" class="text-capitalize">Active</v-chip>
                                            <v-chip v-else color="red" size="small" class="text-capitalize">Inactive</v-chip>     
                                        </template>
    
                                        <template v-slot:item.actions="{ item, index }">
                                            <v-icon
                                                class="me-2 edit-button"
                                                color="primary"
                                                size="small"
                                                @click="editItem(item, index)"
                                                v-if="$updateAccess($route.path)"
                                            >
                                                mdi mdi-pencil-outline
                                            </v-icon>

                                            <v-icon
                                                color="error"
                                                size="small"
                                                @click="deleteItem(item)"
                                            >
                                                mdi-delete
                                            </v-icon>
                                        </template>
                                    </v-data-table>             
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>

                    <!-- <v-row class="d-flex justify-end px-5 mt-2">
                        <v-checkbox                            
                            label="Active"
                            v-model="status.value.value"
                            :error-messages="status.errorMessage.value"
                            density="compact"
                            variant="outlined"
                            hide-details
                            color="primary"
                            class="px-2"
                            value="1"
                        ></v-checkbox>
                    </v-row> -->

                    <v-card-actions>
                        <v-layout class="justify-end">
                        <v-btn class="bg-brand w-15 ms-2" variant="flat" type="submit">
                            {{ isEntryMode ? "Save" : "Update" }}
                        </v-btn>
                        </v-layout>
                    </v-card-actions>
                </v-form>
            </template>
        </v-container>
    </v-app>
</template>

<script>
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { getCurrentInstance, ref, reactive } from "vue";
import { toast } from "vue3-toastify";
import { useRouter } from "vue-router";
import formattedDate from "@/plugins/dateFormatter";
import SalesOrderSetup from "@/components/module/project/projectManagement/salesOrderSetup.vue";
import ContactSetup from '@/components/module/project/settingManagement/contactSetup.vue';
import ProjectThemeSetup from '@/components/module/project/settingManagement/projectThemeSetup.vue';
import ProjectTypeSetup from '@/components/module/project/settingManagement/projectTypeSetup.vue';

export default {
    components: {
        SalesOrderSetup,
        ProjectTypeSetup,
        ProjectThemeSetup,
        ContactSetup,
    },

    data: () => ({
        itemsPerPage: 10,
        panel: [0],
        contactPersonInfo: [0],
        search: "",
        isEntryMode: true,
        dialog: false,
        projectTypeDialog: false,
        projectThemeDialog: false,
        contactDialog: false,
        data: {},
        registrationTypes: [{id: 1, name: 'open', display_text: 'Open'}, {id: 2, name: 'ongoing', display_text: 'Ongoing'}, {id: 3, name: 'closed', display_text: 'Closed'}],
        authors: [],
        headers: [
            { title: "#SL", align: "center", key: "index", width: "7%", sortable: false },
            { title: "Agreed Amount", key: "agreed_amount", align: "left", sortable: false },
            { title: "Payment Date", key: "date_of_enroll", align: "left", sortable: false },
            { title: "Payment Type", key: "payment_type", align: "left" ,sortable: false },
            { title: "Next Payment Date", key: "next_payment_date", align: "left", sortable: false },
            { title: "Previous Paid", key: "paid_amount", align: "left", sortable: false },
            { title: "Receive", key: "receive_amount", align: "left", sortable: false },
            { title: "Due", key: "due_amount", align: "left" ,sortable: false },
            { title: "Actions", align: "center", key: "actions", sortable: false }
        ],
        projectTypes: [
            { id: 1, name: "Special Project" },
            { id: 2, name: "Regular Project" },
            { id: 3, name: "Collaborative Project" },
            { id: 4, name: "Book Chapter" },
            { id: 5, name: "Researcher Project" },
        ],
    }),

    watch: {
        authors: {
            handler(newVal, oldVal) {
            },
            deep: true, 
        },
        '$route.query': {
            handler() {
                this.loadData()
            },
            deep: true,
            immediate: false
        },
        // getProjectTypeList(newList) {
        //     if (
        //         this.$route.query.id &&
        //         this.$store.getters.getEditingProject &&
        //         newList.length > 0
        //     ) {
        //         const project = this.$store.getters.getEditingProject;
        //         this.project_type_id.value.value = project.project_type_id;
        //     }
        // },
        // getContactList(newList) {
        //     if (
        //         this.$route.query.id &&
        //         this.$store.getters.getEditingProject &&
        //         newList.length > 0
        //     ) {
        //         const project = this.$store.getters.getEditingProject;
        //         this.contact_id.value.value = project.contact_id;
        //     }
        // },
        // getProjectThemeList(newList) {
        //     if (
        //         this.$route.query.id &&
        //         this.$store.getters.getEditingProject &&
        //         newList.length > 0
        //     ) {
        //         const project = this.$store.getters.getEditingProject;
        //         this.project_theme_id.value.value = project.project_theme_id;
        //     }
        // },
    },

    created() {
        if (this.$store.getters.getContactList.length === 0) {
            this.$store.dispatch("getContactList");
        }
        if (this.$store.getters.getProjectTypeList.length === 0) {
            this.$store.dispatch("getProjectTypeList");
        }
        if (this.$store.getters.getProjectThemeList.length === 0) {
            this.$store.dispatch("getProjectThemeList");
        }
        if (this.$store.getters.getCustomerMapList.length === 0) {
            this.$store.dispatch("getCustomerMapList");
        }
    },

    computed: {
        getContactList() {
            return this.$store.getters.getContactList;
        },
        getProjectTypeList() {
            return this.$store.getters.getProjectTypeList;
        },
        getProjectThemeList() {
            return this.$store.getters.getProjectThemeList;
        },
        getCustomerMapList() {
            return this.$store.getters.getCustomerMapList;
        },
        getPaidAmount() {
            return this.authors.reduce((sum, author) => +sum + +author.receive_amount, 0);
        }
    },

    methods: {
        openAddAuthor() {
            this.data = {
                amount: this.amount.value.value,
                paid: this.getPaidAmount
            };
            this.dialog = true;
        },
        openAddProjectTheme() {
            this.data = {
                id: '',
                name: '',
                code: '',
                remarks: '',
                status: 1,
            };
            this.projectThemeDialog = true;
        },
        openAddProjectType() {
            this.data = {
                id: '',
                name: '',
                code: '',
                remarks: '',
                status: 1,
            };
            this.projectTypeDialog = true;
        },
        openAddContact() {
            this.data = {
                id: '',
                name: '',
                code: '',
                remarks: '',
                status: 1,
            };
            this.contactDialog = true;
        },

        closeDialog() {
            this.dialog = false;
            this.projectThemeDialog = false;
            this.projectTypeDialog = false;
            this.contactDialog = false;
            this.data = {};
        },

        async onCustomerChange(id) {
            if (!id) {
                this.customer_address.value.value = "";
                return;
            }
            const list = this.$store.getters.getCustomerMapList || [];
            let entry = list.find((it) => {
                return it.customer_id == id || (it.customer && (it.customer.id == id || it.customer.customer_id == id));
            });

            let customer = entry ? entry.customer : null;

            if (!customer) {
                try {
                    customer = await this.$store.dispatch("getCustomerById", id);
                } catch (err) {
                    customer = null;
                }
            }

             if (customer) {
                this.customer_address.value.value = customer.company_address;
             } else {
                this.customer_address.value.value = "";
             }

        },

        saveAuthorHandler(author) {
            if(Number.isInteger(author.array_index)) {
                // const index = this.authors.findIndex(a => a.array_index == author.array_index);
                this.authors[author.array_index] = author;
                // console.log(author);
                // if (index !== -1) {
                //     this.authors.splice(index, 1, author);
                // } else {
                //     this.authors.push(author);
                // }
            } else {
                this.authors.push(author);
            }
            // I want agreed_amount to be sum of all agreed_amount in this.authors
            // this.amount.value.value = this.authors.reduce((sum, author) => +sum + +author.agreed_amount, 0);
        },
        deleteItem(item) {
            if (confirm('Are you sure you want to delete this sales order?')) {
                const index = this.authors.findIndex(order => order.id === item.id);
                if (index !== -1) {
                    this.authors.splice(index, 1);
                    toast.success('Sales order removed successfully');
                    // this.amount.value.value = this.authors.reduce((sum, author) => +sum + +author.agreed_amount, 0);
                }
            }
        },

        editItem(item, index) {
            this.data = { ...item, arrIndex: index, amount: this.amount.value.value, };
            this.dialog = true;
        },

        exportToExcel() {
            var data = [['#SL', 'Project Code', 'Project Title', 'Point of Contact', 'Author Name', 'Author Type', 'Phone', 'Contacted By', 'Agreed Amount', 'Paid', 'Due.', 'Bio']];
            var serialNumber = 1;
            this.authors.forEach(item => {
                data.push([serialNumber++, item.project.code, item.project.project_title, item.project.contacted_by.name, item.name, item.author_type_name, item.phone, item.contacted_by_name, item.agreed_amount, item.paid_amount, item.due_amount, item.bio]);
            });
            this.$exportTableToExcel(data, 'author_list_' + this.$fileDate());
        },

        loadData() {
            // const proxy = this.$.setupState;
            const queryId = this.$route.query.id;
            if (this.$store.getters.getEditingProject && queryId) {
                this.$store.commit('SET_LOADING', { color: 'primary' });
                this.isEntryMode = false;
                const project = this.$store.getters.getEditingProject;
                this.project_id.value.value = project.id;
                this.project_title.value.value = project.project_title;
                this.registration_type.value.value = project.registration_type,
                this.contact_id.value.value = project.contact_id;
                this.project_type_id.value.value = project.project_type_id;
                setTimeout(() => {
                    this.customer_id.value.value = project.customer_id;
                }, 1000);
                this.start_date.value.value = project.start_date;
                this.end_date.value.value = project.end_date;
                this.description.value.value = project.description;
                this.address.value.value = project.address;
                // this.amount.value.value = project.agreed_amount;
                this.amount.value.value = project.amount;
                this.expense_limit.value.value = project.expense_limit;
                this.donor_name.value.value = project.donor_name;
                this.whatsapp_link.value.value = project.whatsapp_link;
                this.google_link.value.value = project.google_link;
                this.approval_ref.value.value = project.approval_ref;
                this.project_date.value.value = project.project_date;
                this.status.value.value = project.status == 1 ? '1' : '0';
                this.authors = [...project.project_payments];
                this.$store.commit('UNSET_LOADING');
            } else {
                this.$store.commit('setEditingProject', null)
                this.project_id.value.value = '';
                this.isEntryMode = true;
                this.resetForm();
                this.authors = []
                this.amount.value.value = 0;
            }
        }
    },
    setup() {
        const { proxy } = getCurrentInstance();
        const { handleSubmit, resetForm } = useForm({
            validationSchema: yup.object({
                project_date: yup.string().required().label("Project Date"),
                project_type_id: yup.number().required().label("Project Type"),
                contact_id: yup.number().required().label("Contact"),
                customer_id: yup.number().required().label("Customer"),
                project_title: yup.string().min(3).required().label("Project Title"),
                amount: yup.number().nullable().label("Amount"),
                start_date: yup.string().required().label("Start Date"),
                end_date: yup.string().required().label("End Date"),
                donor_name: yup.string().max(50).nullable().label("Donor Name"),
                // expense_limit: yup.number().nullable().label("Expense Limit"),
                registration_type: yup.number().required().label("Registration"),
                description: yup.string().nullable(),
                address: yup.string().nullable(),
                approval_ref: yup.string().nullable(),
                whatsapp_link: yup.string().nullable(),
                google_link: yup.string().nullable(),
            }),
        });

        const project_title = useField("project_title");
        const contact_id = useField("contact_id");
        const project_type_id = useField("project_type_id");
        const customer_id = useField("customer_id");
        const customer_address = useField("customer_address");
        const start_date = useField("start_date");
        const end_date = useField("end_date");
        const description = useField("description");
        const address = useField("address");
        const amount = useField("amount");
        const expense_limit = useField("expense_limit");
        const donor_name = useField("donor_name");
        const registration_type = useField("registration_type");
        const whatsapp_link = useField("whatsapp_link");
        const google_link = useField("google_link");
        const approval_ref = useField("approval_ref");
        const project_date = useField("project_date");
        const authors = ref([]);

        const status = useField("status");
        const project_id = useField('project_id');

        const errorMessages = ref("");
        const loading = ref("");
        const isEntryMode = ref(true);
        
        const store = useStore();
        const router = useRouter();

        const submit = handleSubmit((values) => {
            values.project_date = formattedDate(project_date.value.value);
            values.start_date = formattedDate(start_date.value.value);
            values.end_date = formattedDate(end_date.value.value);
            values.status = '1';
            values.authors = proxy.authors;

            loading.value = true;
            store
                .dispatch("saveUpdateProject", values)
                .then((response) => {
                resetForm();
                loading.value = false;
                toast.success(response.data.message, {
                    timeout: 3000,
                });
                setTimeout(() => {
                    store.dispatch("getProjectList");
                    router.push({ name: "project-record" });
                }, 2000);
                })
                .catch((error) => {
                loading.value = false;
                    console.error("Error:", error);
                    toast.error(error.response?.data?.message || "An error occurred");
                });
        });

        return {
            formattedDate,
            submit,
            project_title,
            contact_id,
            project_type_id,
            customer_id,
            customer_address,
            start_date,
            end_date,
            description,
            address,
            amount,
            expense_limit,
            donor_name,
            registration_type,
            whatsapp_link,
            google_link,
            approval_ref,
            project_date,
            authors,
            status,
            errorMessages,
            isEntryMode,
            project_id,
            resetForm,
            loading,
        };
    },

    mounted() {
       this.loadData()
    },
};
</script>
